/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Manager_Delivery_LinkInputs */

const vi_dashboard_manager_delivery_link = /** @type {(inputs: Dashboard_Manager_Delivery_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem báo cáo giao hàng`)
};

/**

* @param {Dashboard_Manager_Delivery_LinkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_manager_delivery_link = /** @type {((inputs?: Dashboard_Manager_Delivery_LinkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Manager_Delivery_LinkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_manager_delivery_link(inputs)
});